// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgGolf = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.034 2.056A.75.75 0 0 0 9 2.75v9.292c-2.14.184-3.66.952-4.742 1.892-1.217 1.056-1.834 2.29-2.172 2.966l-.007.015A.75.75 0 0 0 2.75 18h14.5a.75.75 0 0 0 .67-1.085l-.006-.015c-.338-.676-.956-1.91-2.172-2.966-1.165-1.011-2.837-1.824-5.242-1.924V7.754l5.034-2.06a.75.75 0 0 0 0-1.388l-5.5-2.25ZM9 13.548v.702a.75.75 0 0 0 1.5 0v-.738c2.038.096 3.365.78 4.258 1.554.53.46.921.964 1.222 1.434H4.02c.3-.47.692-.974 1.222-1.434.818-.71 2-1.342 3.758-1.518ZM13.27 5 10.5 6.133V3.867L13.27 5Z"
    />
  </svg>
)

export default SvgGolf
